(function () {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    /**
     * Provides methods for handling frequencies (prescription, protocol prescription, etc.).
     *
     * It converts between frequency represented as a "frequencyPerDay" attribute and two temporary
     * attributes "_frequencyOption" and "_frequencyNumber", which can be bound to HTML element
     * to make it easy for a user to understand on a form.
     */
    angular
        .module('ihh-common-web')
        .service('FrequencyService', FrequencyService);

    FrequencyService.$inject = ['_'];

    function FrequencyService(_) {
        var self = this;

        var defaultOption = {
            label: 'Once a Day',
            id: '1Per1Day',
            value: 1 / 1
        };

        var customOption = {
            label: 'Specified Number of Days',
            id: 'custom',
            custom: true
        };

        self.getFrequencyLabel = getFrequencyLabel;
        self.updateFrequency = updateFrequency;
        self.initFrequency = initFrequency;

        self.frequencyOptions = [
            defaultOption,
            {
                label: 'Twice a Day',
                id: '2Per1Day',
                value: 2 / 1
            }, {
                label: 'Three Times a Day',
                id: '3Per1Day',
                value: 3 / 1
            }, {
                label: 'Five Times a Day',
                id: '5Per1Day',
                value: 5 / 1
            }, {
                label: 'Once a Week',
                id: '1Per7Days',
                value: 1 / 7
            }, {
                label: 'Twice a Week',
                id: '2Per7Days',
                value: 2 / 7
            }, {
                label: 'Three Times a Week',
                id: '3Per7Days',
                value: 3 / 7
            }, {
                label: 'Every Other Day',
                id: '1Per2Days',
                value: 1 / 2
            },
            customOption
        ];

        /*
         * Initializes the temporary fields of the passed object based on the object's "frequencyPerDay" field.
         */
        function initFrequency(obj) {
            obj._frequencyOption = getFrequencyOption(obj);
            obj._frequencyNumber = 1 / obj.frequencyPerDay;
        }

        /*
         * Updates the frequencyPerDay of the passed object, based on the ephemeral values from the
         * HTML input elements for frequency type and frequency number.
         */
        function updateFrequency(obj) {
            if (obj && obj._frequencyOption) {
                if (obj._frequencyOption.id === customOption.id) {
                    obj.frequencyPerDay = 1 / obj._frequencyNumber;
                }
                else {
                    obj.frequencyPerDay = obj._frequencyOption.value;
                }
            }
        }

        /**
         * Returns the frequency option appropriate for the passed object.
         *
         * @param {type} obj the object to check
         * @returns {Object} the frequency object; never null or undefined
         */
        function getFrequencyOption(obj) {
            if (obj && obj.frequencyPerDay) {

                var option = _.find(self.frequencyOptions, function(item) {
                    return item.value === obj.frequencyPerDay;
                });

                return option || customOption;
            }

            return defaultOption;
        }

        /**
         * Returns a label describing the frequency of the passed object.
         * @param {Object} obj the object to describe its frequency
         */
        function getFrequencyLabel(obj) {
            if (!obj || !obj.frequencyPerDay) {
                return 'N/A';
            }

            var option = getFrequencyOption(obj);

            return option.id === customOption.id
                ? 'Every ' + (1 / obj.frequencyPerDay) + ' days'
                : option.label;
        }
    }
})();